import PropTypes from "prop-types";
import { SearchOutlined } from "@/config/antd";
import Input from "@/components/common/inputs/Input";
import Button from "@/components/common/Button";
import {
  formatRelativeTimestamp,
  isRootSupportTicket,
} from "@/utils/supportUtils";

const SupportTicketList = ({
  tickets,
  loading,
  searchQuery,
  onSearchChange,
  onTicketSelect,
  onSeeAll,
}) => {
  const rootTickets = (tickets || []).filter(isRootSupportTicket);

  const filteredTickets = rootTickets
    .filter(
      (ticket) =>
        !searchQuery ||
        ticket.subject?.toLowerCase().includes(searchQuery.toLowerCase())
    )
    .map((ticket) => ({
      id: ticket._id,
      subject: ticket.subject || "",
      from: ticket.userID?.fullname || "",
      time: formatRelativeTimestamp(ticket.createdAt),
      status: ticket.status,
    }));

  return (
    <div className="w-full text-left">
      <h1 className="text-medium font-semibold mb-2">
        Chat with Veegil Customers Support
      </h1>
      <p className="text-small text-lighterGrey mb-6">
        You can get immediate problems solved from our customer support team
        from here and as fast as you can.
      </p>

      <div className="mb-6">
        <Input
          placeholder="Search for Help"
          icon={<SearchOutlined />}
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="bg-gray-50"
        />
      </div>

      {loading && (
        <div className="text-center py-4">
          <p>Loading support tickets...</p>
        </div>
      )}

      {!loading && filteredTickets.length === 0 && (
        <div className="text-center py-4">
          <p>No support tickets found</p>
        </div>
      )}

      <div className="space-y-6">
        {filteredTickets.map((ticket) => (
          <div
            key={ticket.id}
            className="border-l-4 border-primary pl-4 py-2 hover:bg-secondary cursor-pointer"
            onClick={() => onTicketSelect(ticket.id)}>
            <h3 className="text-regular mb-2 truncate w-[200px]">
              {ticket.subject}
            </h3>
            <div className="flex justify-between text-sm text-gray-500">
              <span className="text-small">
                {ticket.from ? `From ${ticket.from}` : ""}
              </span>
              <span className="text-small">{ticket.time}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 bg-secondary p-4 rounded-lg">
        <p className="text-small mb-4">
          Click below to view all customer tickets opened
        </p>
        <Button
          text="SEE ALL MESSAGES"
          color="primary"
          isActive={true}
          className="w-full"
          onClick={onSeeAll}
        />
      </div>
    </div>
  );
};

SupportTicketList.propTypes = {
  tickets: PropTypes.array,
  loading: PropTypes.bool,
  searchQuery: PropTypes.string,
  onSearchChange: PropTypes.func.isRequired,
  onTicketSelect: PropTypes.func.isRequired,
  onSeeAll: PropTypes.func.isRequired,
};

export default SupportTicketList;
